// Match the media ticket limits before creating a tree or observation.
export function photoError(file: { name: string; type: string; size: number }): string {
  if (!file.type.startsWith('image/')) return 'Choose an image file.'
  if (!file.size) return 'This photo is empty. Choose another photo.'
  if (file.size > 12 * 1024 * 1024) return 'Choose a photo smaller than 12 MB.'
  if (!file.name || file.name.length > 180) return 'Use a photo filename of 180 characters or fewer.'
  return ''
}
